export default class SVGFloorParser
{
	constructor(svg)
	{
		this.svg = svg;

	}

	get_names(parentNode)
	{
		let names = [];
		if(!parentNode)
			return names;

		let nodes = parentNode.getElementsByTagName("path");
		for(let i=0; i< nodes.length; i++)
		{
			names.push(nodes[i].getAttribute("id"));
		}
		return names;
	}
	parse(floor_name)
	{

		let units_group = new THREE.Group();
		units_group.name = "Units";

		let details_group = new THREE.Group();
		details_group.name = "Details";

		let portals_group = new THREE.Group();
		portals_group.name = "Portals";

		let streets_group = new THREE.Group();
		streets_group.name = "Streets";

		let slabs_group = new THREE.Group();
		slabs_group.name = "Slabs";


		let unit_names 		= this.get_names(this.svg.xml.getElementById("Units"));
		let portal_names 	= this.get_names(this.svg.xml.getElementById("Portals"));
		let details_names = this.get_names(this.svg.xml.getElementById("Details"));
		let streets_names = this.get_names(this.svg.xml.getElementById("Streets"));
		let slabs_names 	= this.get_names(this.svg.xml.getElementById("Slabs"));

		let meshes = this.generate_meshes(unit_names);


		for(let i=0; i<meshes.length; i++)
		{
			if(unit_names.includes(meshes[i].name))
				units_group.add(meshes[i]);

			if(details_names.includes(meshes[i].name))
				details_group.add(meshes[i]);

			if(slabs_names.includes(meshes[i].name))
				slabs_group.add(meshes[i]);

			if(portal_names.includes(meshes[i].name))
				portals_group.add(meshes[i]);

			if(streets_names.includes(meshes[i].name))
				streets_group.add(meshes[i]);
		}


		let floor = new THREE.Group();
		floor.name = floor_name;

		floor.add(units_group);
		floor.add(details_group);
		floor.add(slabs_group);
		floor.add(streets_group);
		floor.add(portals_group);

		return floor;
	}

	compute_indices(geometry)
	{
		let vertex_count = geometry.getAttribute("position").count;
		let indices = [];


		for(let i=0; i< vertex_count; i++)
		{
			indices.push(i);
		}
		geometry.clearGroups();
		geometry.setIndex(indices);
	}
	generate_meshes(unit_names)

	{
		var paths = this.svg.paths;

    var drawFillShapes = true;
    var fillShapesWireframe = false;
    var strokesWireframe =false;
		var group = new THREE.Group();



		var extrudeSettings = {
			steps: 1,
			depth: 3,
			bevelEnabled: false,
			bevelThickness: 0.1,
			bevelSize: 0.5,
			bevelOffset: 0,
			bevelSegments: 20
		};

		let meshes = [];

		for ( var i = 0; i < paths.length; i ++ ) {
			var path = paths[ i ];
			var fillColor = path.userData.style.fill;
			if ( drawFillShapes && fillColor !== undefined && fillColor !== 'none' ) {
				var material = new THREE.MeshStandardMaterial( {
					color: new THREE.Color().setStyle( fillColor ),
					opacity: path.userData.style.fillOpacity,
					transparent: path.userData.style.fillOpacity < 1,
					// side: THREE.DoubleSide,
					// depthWrite: false,
					wireframe: fillShapesWireframe
				} );
				var shapes = path.toShapes( true );
				for ( var j = 0; j < shapes.length; j ++ ) {
					var shape = shapes[ j ];
					var geometry = undefined;
					if(unit_names.includes(path.name))
					{
						// geometry = new THREE.ExtrudeBufferGeometry( shape, extrudeSettings );
						geometry = THREE.BufferGeometryUtils.mergeBufferGeometries([new THREE.ExtrudeBufferGeometry( shape, extrudeSettings )])
						this.compute_indices(geometry);
					}
					else
						geometry = new THREE.ShapeBufferGeometry( shape );

					geometry.rotateX(-Math.PI/2)
					var mesh = new THREE.Mesh( geometry, material );
					mesh.name = path.name;
					mesh.parentName = path.parentName;
					meshes.push(mesh);
				}
			}

		}

    // group.traverse((child)=>{
    // 	if(child.geometry)
    // 	{
    // 		child.geometry.rotateX(-Math.PI/2);
    // 	}
    // });
    return meshes;
	}
}